<template>
  <div class="c_selectbox">
    <select @focus="focus" @change="action" v-model="selected" :disabled="disabled">
      <option value="-99">{{ defaultText }}</option>
      <option v-for="(data, index) in this.abstractList"
              :key="index"
              :value="data.item_id">{{ data.item }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import app from '../constant/app_config.js'
export default {
  name: 'CSelectBox',
  props: {
    list: { type: Array, required: true },
    registerId: { type: String, required: true },
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters({
      selectedMonth: 'FormRegisterUser/selectedMonth'
    })
  },
  data: function () {
    return {
      selected: '', // デフォルト値
      abstractList: null,
      defaultText: '選択しない',
      defaultValue: '-99'
    }
  },
  mounted: function () {
    this.abstractList = this.list
    if (this.value && this.value !== '') { this.updateSelected(this.value) }

    // automatically set selected month when mounted
    if (this.registerId === app.api.month) {
      console.log('**** checking month ******')
      console.log(this.list)
      console.log(this.value)
      console.log(this.registerId)
      const finder = this.list.filter(x => x.item_id === this.value)
      if (finder.length > 0) {
        this.actionSetSelectedMonth(finder[0].item)
      }
    }

    if (this.registerId === app.api.date) {
      if (this.selectedMonth.indexOf('月') === -1) {
        this.abstractList = []
      }
    }
  },
  watch: {
    list: function (value) {
      this.abstractList = value
    },
    value: function (value) {
      console.log(value)
      if (value && value !== '') {
        this.updateSelected(value)
      }
    },
    selectedMonth: function (value) {
      if (this.registerId === app.api.date) {
        const odd = ['1月', '3月', '5月', '7月', '8月', '10月', '12月']
        if (!odd.includes(value)) {
          // check if month if february
          if (String(value) === '2月') {
            this.abstractList = this.list.filter(x => x.item !== '30日' && x.item !== '31日')
          } else {
            // 30 days
            this.abstractList = this.list.filter(x => x.item !== '31日')
          }
        } else {
          this.abstractList = this.list
        }

        if (value.indexOf('月') === -1) {
          this.abstractList = []
        }
      }
    }
  },
  methods: {
    ...mapActions('FormRegisterUser', ['actionSetSelectedMonth']),
    focus (e) {
      if (!this.value) {
        const data = JSON.parse(JSON.stringify(this.list[0]))
        const value = (this.selected.length > 0) ? this.selected : ''
        const item = (this.selected.length > 0) ? data.item : this.defaultText
        const payload = { registerId: this.registerId, item_id: value, item: item }
        this.selected = value
        this.$emit('focus', payload)
      } else {
        if (this.value.length === 0) {
          const data = JSON.parse(JSON.stringify(this.list[0]))
          const value = (this.selected.length > 0) ? this.selected : ''
          const item = (this.selected.length > 0) ? data.item : this.defaultText
          const payload = { registerId: this.registerId, item_id: value, item: item }
          this.selected = value
          this.$emit('focus', payload)
        }
      }
    },
    action (e) {
      const value = (e.target.selectedOptions[0].value !== '-99') ? e.target.selectedOptions[0].value : ''
      const item = e.target.selectedOptions[0].text
      const payload = { registerId: this.registerId, item_id: value, item: item }
      this.$emit('input', payload)
      this.$emit('change', payload)
      this.selected = value
    },
    updateSelected (value) {
      console.log(value)
      const target = this.list.find(data => data.item_id === value)
      if (!target) return
      this.selected = target.item_id
    }
  }
}
</script>

<style scoped>
.c_selectbox > select {
  font-size: 14px;
  width: 100%;
  height: 22px;
  letter-spacing: 1px;
  font-family: HiraKakuPro-W6;
  background-color: #ffffff;
  appearance: none;
  border: none;
  font-weight: bold;
  outline: none;
}
</style>
